import * as React from 'react';
import './rvChart.css';

interface ChartHeadingProps {
    // a small outlined MUI icon that says what kind of chart this is
    icon: React.ReactNode;
    title: React.ReactNode;
    // the period shown, for charts that have period options
    subtitle?: React.ReactNode;
}

// The heading of a restyled Firm Dashboard chart: an icon chip, the title, and the period under it. Display only - the chart's
// buttons, totals and handlers stay where they were. Looks come from rvChart.css (inside an element with the rv-chart class).
export const ChartHeading: React.FC<ChartHeadingProps> = ({ icon, title, subtitle }) => (
    <div className="rv-chart-heading">
        <span className="rv-chart-icon" aria-hidden={true}>{icon}</span>
        <div className="rv-chart-heading-text">
            <h1 className="rv-chart-title">{title}</h1>
            {subtitle ? <div className="rv-chart-subtitle">{subtitle}</div> : null}
        </div>
    </div>
);
